import { React, useState, useEffect, useLayoutEffect, useRef, useMemo } from "react";
import JobCardCylinderChild from "./JobCardCylinderChild";
import moment from "moment";
import { transformPatternData, patterns } from "../../Utils/helper/helper";
import { Tooltip } from "antd";
import {
  currency_List,lengthUnit,weightUnit
  } from "../../Utils/Constant/MeasurementUnitList.jsx";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const SheetJobCardCylinder = ({ cylinderData, multiview, jobCard,unitData }) => {
  const divRef = useRef();
  const [width, setwidth] = useState();
  const [trList, settrList] = useState();
  const data = useMemo(() => transformPatternData(cylinderData, jobCard,unitData), [cylinderData, jobCard, unitData]);
  const updateContainerWidth = () => {
    if (!divRef.current) return;
    const containerWidth = divRef.current.offsetWidth;
    if (containerWidth <= 120) return;
    const nextWidth = containerWidth - 120;
    setwidth((prevWidth) => (prevWidth !== nextWidth ? nextWidth : prevWidth));
  };

  const [widthChange, setWidthChange] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setWidthChange(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useLayoutEffect(() => {
    updateContainerWidth();
    if (!divRef.current || typeof ResizeObserver === "undefined") return;
    const resizeObserver = new ResizeObserver(() => {
      updateContainerWidth();
    });
    resizeObserver.observe(divRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [widthChange, data]);

  useEffect(() => {
    if (width && data && data.length) {
      const _trList = data.map((row) => {
        const height =
          (row.row_meta.length / row.row_meta.deckle_length) * width;
        // console.log(width, height);
        return (
          <div style={{ display: "flex" }}>
            <div className="sheet-row" style={{ width }}>
              {row.tr.map((td) => (
                <Tooltip
                  title={
                    td.type.toLowerCase() == "stock"
                      ? `Stock No.: ${td.order_id} \n Size: ${td.breadth} X ${
                        row.row_meta.length
                      }
                      Grain: ${td.grain.toLowerCase() === 'short' ? 'Short' : 'Long'} 
                                Weight: ${td.weight.toFixed(3)} ${row.row_meta.units ? capitalize(weightUnit[row.row_meta.units.weight].displayName) : ''}
                                Priority:  ${td.priority === 1 ? 'Yes' : 'No'}`
                      : `Order No.: ${td.order_id} \n Size:${td.breadth + (row.row_meta.units ? ' ' + (lengthUnit[row.row_meta.units.breadth].displayName).toUpperCase() : '')} X ${
                        row.row_meta.length + (row.row_meta.units ? ' ' + (lengthUnit[row.row_meta.units.length].displayName).toUpperCase() : '')
                      }
          Grain: ${td.grain.toLowerCase() === 'short' ? 'Short' : 'Long'} 
                    Weight: ${td.weight.toFixed(3)} ${row.row_meta.units ? capitalize(weightUnit[row.row_meta.units.weight].displayName) : ''}
                    Priority: ${td.priority === 1 ? 'Yes' : 'No'}
                    `
                  }
                >
                  <div
                    className="sheet-col"
                    style={{
                      width: `${td.percentWidth}%`,
                      height,
                      minHeight: "70px",
                      backgroundColor:
                        td.type.toLowerCase() === "order" && !td.priority
                          ? "#FBE0DE"
                          : td.type.toLowerCase() === "order" && td.priority
                          ? "#FB967F"
                          : "#FDF0EF",
                    }}
                  >
                    {(td.percentWidth / 100) * width > 30 ? (
                      <span>{td.breadth} {(row.row_meta.units ? ' ' + (lengthUnit[row.row_meta.units.breadth].displayName) : '')}</span>
                    ) : (
                      <span>.</span>
                    )}
                  </div>
                </Tooltip>
              ))}
              <Tooltip key={row.tr.length} title={`Type: Trim Loss\nTrim Loss: ${row?.row_meta?.trim_loss_width} ${row?.row_meta?.units?.trim_loss_width}`}>
                <div
                className="sheet-col"
                style={{
                  width: `${row.row_meta.percentTrimLossWidth}%`,
                  height,
                  minHeight: "70px",
                  backgroundColor: "white",
                  border: "none",
                }}
                ></div>
                </Tooltip> 
            </div>
            <div
              style={{
                width: "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "5px",
              }}
            >
              <span
                style={{ fontSize: "12px", lineHeight: "16px", width: "120px" }}
              >
                Trim Loss: {row.row_meta.trim_loss_width.toFixed(3) + (row.row_meta.units ? ' ' + (lengthUnit[row.row_meta.units.trim_loss_width].displayName).toUpperCase() : '')} 
                <p style={{ fontSize: "10px", lineHeight: "16px" }}>
                  Chop: {row.row_meta.length + (row.row_meta.units ? ' ' + (lengthUnit[row.row_meta.units.length].displayName).toUpperCase() : '')} 
                </p>
                <p style={{ fontSize: "10px", lineHeight: "16px" }}>
                  Del: {moment(row.row_meta.deadline).format("DD MMM YYYY")}
                </p>
                <p style={{ fontSize: "10px", lineHeight: "16px" }}>
                  Weight: {row.row_meta.totalWeight.toFixed(3) + (row.row_meta.units ? ' ' + capitalize(weightUnit[row.row_meta.units.weight].displayName) : '')} 
                </p>
              </span>
            </div>
          </div>
        );
      });
      settrList(_trList);
    }
  }, [width, data]);

  return  (
      <div ref={divRef} onResize={handleWindowSizeChange}>
        {trList}
      </div>
  );
};

export default SheetJobCardCylinder;
